import { del, get, patch, post, put } from '../client';

export const villagersApi = {
  list: (params) => get('/villagers', { params }),
  getById: (id) => get(`/villagers/${id}`),
  create: (body) => post('/villagers', body),
  update: (id, body) => put(`/villagers/${id}`, body),
  updateKyc: (id, body) => patch(`/villagers/${id}/kyc`, body),
  remove: (id) => del(`/villagers/${id}`),
};
